<template>
  <div>
    <!-- 创建一个div，并设置id为qrcode -->
    <div id="qrcode"></div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2' // 引入qrcode
export default {
  name: 'test',
  data() {
    return {
      qrcode: null,
    }
  },
  props: ['moduleId', 'taskid', 'uuid'],
  mounted() {
    this.initQRCode()
  },
  methods: {
    initQRCode() {
      const { url } = this.getUrl()
      this.qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200,
        text: url, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },
    getUrl() {
      const origin = location.origin.replace(/design/, 'design-m')
      const url =
        origin +
        '/esign?moduleId=' +
        this.moduleId +
        '&uuid=' +
        this.uuid +
        '&taskid=' +
        this.taskid
      return {
        url,
      }
    },
  },
  watch: {
    uuid() {
      const { url } = this.getUrl()
      this.qrcode.clear() // clear the code.
      this.qrcode.makeCode(url) // make another code.
    },
  },
}
</script>
